// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as LumiReact from "lumi-rescript/lib/es6/src/LumiReact.res.js";
import * as JsxRuntime from "react/jsx-runtime";

function use(init) {
  let match = React.useState(init);
  let setShowDialog = match[1];
  let showDialog = match[0];
  let openDialog = React.useCallback(() => setShowDialog(param => true), []);
  let closeDialog = React.useCallback(() => setShowDialog(param => false), []);
  return React.useMemo(() => ({
    showDialog: showDialog,
    closeDialog: closeDialog,
    openDialog: openDialog
  }), [
    openDialog,
    closeDialog,
    showDialog
  ]);
}

function Dialog(props) {
  let closeDialog = props.closeDialog;
  let __showDialog = props.showDialog;
  let showDialog = __showDialog !== undefined ? __showDialog : true;
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("div", {
        className: "modal-background",
        onClick: param => closeDialog()
      }),
      JsxRuntime.jsx("div", {
        children: props.children,
        className: "modal-card"
      }),
      JsxRuntime.jsx("button", {
        className: "modal-close is-large",
        onClick: param => closeDialog()
      })
    ],
    className: LumiReact.classList([
      [
        "modal",
        true
      ],
      [
        "is-active",
        showDialog
      ]
    ])
  });
}

let make = Dialog;

export {
  use,
  make,
}
/* react Not a pure module */
